<template>
  <div id="modal-body">
    <b-row class="report-form">
      <b-col sm="12">
        <p class="sub">상품에 오류가 있는 경우 등록해주시면 확인하고 반영하겠습니다.</p>
        <p>{{name}}</p>
        <b-input-group>
          <b-form-textarea class="content-textarea" v-model="content" @keyup.enter="submit" placeholder="오류내용"></b-form-textarea>
        </b-input-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BIconCheck
} from 'bootstrap-vue'
import { api_post } from '../../util'

export default {
  name: 'ReportModal',
  components: {
    BRow, BCol, BIconCheck
  },
  props: {
    _id: {
      type: String,
      required: true
    },
    name: String
  },
  data () {
    return {
      content: ''
    }
  },
  methods: {
    submit () {
      return api_post(`report/${this._id}`, {
        content: this.content
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
p.sub {
  color: grey;
  font-size: 0.8rem;
}
.content-wrapper {
  position: relative;
  padding: 30px;
}

.content-textarea {
  height: 200px;
}
.input-group {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ReportModal.vue